import React from "react";
import axios from "axios";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { AllProducts } from "./sections/AllProducts";
import { useDispatch, useSelector } from "react-redux";
import { getProducts } from "../actions/productActions";
import { useEffect, useState } from "react";
import Loader from "../components/Loader";
import { toast } from "react-toastify";
import { loginSuccess, loginFail } from "../slices/authSlice";
import Swal from "sweetalert2";
import Productgrid from "./sections/Productgrid";
import { Link } from "react-router-dom";

const Products = () => {
  const [orderDetails, setOrderDetails] = useState({
    productName: "",
    productWeight: "",
  });
  const [currentgoldprice, setCurrentgoldprice] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();

  //get current price from databse
  useEffect(() => {
    const fetchCurrentPrice = async () => {
      try {
        const response = await axios.get(
          "/goldprice/admin/show"
        );

        setCurrentgoldprice(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchCurrentPrice();
  }, []);

  console.log(currentgoldprice);

  const { subcategory } = useParams();

  // Use the useSelector hook to get the products state from Redux store

  const dispatch = useDispatch();
  const { products, loading, error } = useSelector(
    (state) => state.productsState
  );
  const { isAuthenticated } = useSelector((state) => state.authState);

  useEffect(() => {
    if (error) {
      return toast.error(error, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
    dispatch(getProducts());
  }, [dispatch, error]);

  const activePrice = currentgoldprice && currentgoldprice.length > 0 ? currentgoldprice[0] : null;

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <div className="p-10 text-center text-red-500">Error: {error}</div>;
  }

  if (!Array.isArray(products)) {
    console.error("Products is not an array:", products);
    return <div className="p-10 text-center">No products found.</div>;
  }

  const filteredProducts = products.filter(
    (product) => product.subcategory === subcategory
  );

  const handleBuyNowClick = (id) => {
    navigate(`/product/${id}`);
  };

  return (
    <div className="container mx-auto px-4">
      <h2 className="text-2xl font-bold my-6 capitalize">{subcategory?.replace(/([A-Z])/g, ' $1').trim()}</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 my-10">
        {filteredProducts.map((product, index) => (
          <div key={index} className="mb-10">
            <div className="max-w-md mx-auto rounded-md overflow-hidden shadow-md hover:shadow-lg transition-shadow bg-white">
              <Link to={`/product/${product._id}`}>
                <div className="relative lg:h-96 overflow-hidden">
                  <img
                    className="w-full h-full object-contain"
                    src={product.images && product.images.length > 0 ? product.images[0].image : "/images/default_product.png"}
                    alt={product.name}
                  />
                  <div className="absolute top-0 right-0 bg-red-500 text-white px-2 py-1 m-2 rounded-md text-sm font-medium">
                    SALE
                  </div>
                </div>
              </Link>
              <div className="p-4">
                <Link to={`/product/${product._id}`}>
                  <h3 className="text-lg font-medium mb-2 hover:text-yellow-600 truncate">
                    {product.name}
                  </h3>
                </Link>
                <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                  {product.description}
                </p>

                <div className="flex items-center justify-between">
                  <span className="font-bold text-lg">
                    {activePrice ? (
                       <>Rs {(activePrice.goldprice / 8) * product.weight + (activePrice.goldprice * product.makingrate) / 100}</>
                    ) : (
                       <span className="text-sm text-gray-400 italic">Calculating...</span>
                    )}
                  </span>

                  <button
                    className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-2 px-4 rounded text-sm transition-colors"
                    onClick={() => handleBuyNowClick(product._id)}
                  >
                    Buy Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {filteredProducts.length === 0 && (
        <div className="text-center py-20 text-gray-500">
           No products found in this category.
        </div>
      )}
    </div>
  );
};

export default Products;
